import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { axiosInstnace as Axios } from "../../util/util";
import { endPoints } from "../../config";
import Pagination from "../admin/common/Pagination";
import NoData from "../admin/common/NoData";
import ReactAudioPlayer from "react-audio-player";
import { history } from "../../history/history";

const MultipleaudioList = ({hide, audios }) => {
  //Set initial state
  const [audioList, handleAudioManagementList] = useState(audios);
  var reactAudio = useRef(undefined);

  useEffect(() => {
    handleAudioManagementList(audios)
  }, []);

  

  return (
    <div className="dashboardContainer remark-popup">
      <div className="modal-overlay">
        <div
          className="modal-wrapper existing-audio-popup"
          aria-modal
          aria-hidden
          role="dialog"
        >
          <form className="form-group">
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={hide}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <div className="running_cap_head">
                    <h2 className="camp_head">Audio List</h2>
                   </div>
                  </div>

                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs nonFct">
                        <div className="dashboard-content userListing-dashboard bg-white table-responsive">
                          <table
                            className={
                              audioList.length > 0
                                ? "table master-table contact_list"
                                : "table master-table contact_list none"
                            }
                          >
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Audio File</th>
                                <th>Audio</th>
                              </tr>
                            </thead>
                            <tbody>
                              {audioList &&
                                audioList.map((a, i) => (
                                  <React.Fragment>
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{a.name}</td>
                                      <td>
                                        <ReactAudioPlayer
                                          src={a.awsurl}
                                          controls
                                          controlsList="nodownload"
                                        />
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))}
                            </tbody>
                          </table>
                        </div>
                        {audioList.length === 0 ? <NoData /> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default MultipleaudioList;



// WEBPACK FOOTER //
// ./web/components/common/audiolist.js